import { Grid, Typography } from "@mui/material"
import { WorkItemTitle } from "./WorkItemTitle"
import ForumIcon from '@mui/icons-material/Forum'
import SaveIcon from '@mui/icons-material/Save'

type TitleSectionPropsType = {
  workType?: string
  totalCommentCount: number
  itemId: number
  itemTitle?: string
  isButtonActive: boolean
  onClickSaveButton: () => void
}

export const TitleSection = (props: TitleSectionPropsType) => {
  return (
    <Grid container style={{ marginTop: '30px', width: '100%' }}>
      <Grid item md={1} xs={1} style={{
        maxWidth: '12px',
        backgroundColor: props.workType === 'Bug' ? 'rgb(204, 41, 61)'
          : props.workType === 'Task' ? 'rgb(242, 203, 29)'
            : props.workType === 'User Story' ? 'rgb(0, 156, 204)'
              : props.workType === 'Feature' ? 'rgb(119, 59, 147)'
                : 'red'
      }}>
      </Grid>
      <Grid item className='itemCard' md={11} xs={11}>
        <WorkItemTitle workType={props.workType} id={props.itemId} />
        <Typography pt={2} pb={2}>
          {props.itemId}
          {'  '}
          {props.itemTitle}
        </Typography>
        <Grid container >
          <Grid item md={4} xs={12}>
          </Grid>
          <Grid item md={4} xs={12}>
            <Typography style={{ display: 'inline-flex', paddingBottom: '20px' }}>
              <ForumIcon fontSize="small" color='info' />
              <span className='smallTitle'>{props.totalCommentCount}</span>
              <span className='smallTitle'> comments </span>
            </Typography>
          </Grid>
          <Grid item md={4} xs={12} style={{ float: 'right' }}>
            <Typography
              onClick={props.onClickSaveButton}
              variant='caption' className={props.isButtonActive ? 'saveButtonActive' : 'saveButton'}
              style={{ display: 'inline-flex', float: 'right',alignItems: 'self-end', marginBottom: '5px' }}
            >
              <SaveIcon />
              <span>Save</span>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
